import { defineComponent as _defineComponent } from 'vue'
import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'

  import useCommonMixin from '@/composables/useCommonMixin'
  import useIcons from '@/composables/useIcons'
  import useCourse from '@/composables/useCourse'
  import useShopifyClient from '@/composables/useShopifyClient'

  import { UserModule } from '@/store/modules/user'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'BuyCourseDetails',
  setup(__props) {

  const { hasValidUser } = useCommonMixin()
  const { course, isTrialExpired, lessonsAndDuration, coursePurchasePerksToShow } = useCourse()
  const { createShopifyCheckout } = useShopifyClient()

  const { mediaIcon, starIcon, arrowRightIndicator } = useIcons()

  const buyNow = () => {
    createShopifyCheckout(UserModule.email || undefined, course.value?.shopifyProductVariantId)
  }

return { __sfc: true,hasValidUser, course, isTrialExpired, lessonsAndDuration, coursePurchasePerksToShow, createShopifyCheckout, mediaIcon, starIcon, arrowRightIndicator, buyNow, KetchUpButton, SVGRenderer, useCommonMixin, useIcons, useCourse, useShopifyClient, UserModule }
}

})